import axios from "axios";
import toast from "react-hot-toast";

// Use environment variable for backend URL
const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Create a new candidate (POST /api/Candidate)
export const createCandidate = async (formData) => {
    try {
        const response = await axios.post(
            `${BASE_URL}/Candidate`,
            formData,
            {
                headers: { "Content-Type": "multipart/form-data" },
                withCredentials: true
            }
        );
        toast.success("Candidate registered successfully");
        return response.data;
    } catch (error) {
        console.error("Error creating candidate:", error);
        const msg = error.response?.data?.message || "Candidate registration unsuccessful";
        toast.error(
            msg.includes("Employee ID already exists")
                ? "Please use a different Employee ID."
                : msg
        );
        throw error;
    }
};

// Update an existing candidate (PUT /api/update/{empId})
export const updateCandidate = async (empId, formData) => {
    try {
        const response = await axios.put(
            `${BASE_URL}/update/${empId}`,
            formData,
            {
                headers: { "Content-Type": "multipart/form-data" },
                withCredentials: true
            }
        );
        toast.success("Candidate updated successfully");
        return response.data;
    } catch (error) {
        console.error("Error updating candidate:", error);
        toast.error("Candidate update unsuccessful");
        throw error;
    }
};

// Get all candidates (GET /api/getAllCandidates)
export const getAllCandidates = async () => {
    try {
        const response = await axios.get(
            `${BASE_URL}/getAllCandidates`,
            { withCredentials: true }
        );
        return response.data;
    } catch (error) {
        console.error("Error fetching candidates:", error);
        toast.error("Failed to fetch candidates");
        throw error;
    }
};

// Get candidates by election ID (GET /api/election/{electionId}/candidates)
export const getCandidatesByElection = async (electionId) => {
    try {
        const response = await axios.get(
            `${BASE_URL}/election/${electionId}/candidates`,
            { withCredentials: true }
        );
        return response.data;
    } catch (error) {
        console.error("Error fetching candidates by election:", error);
        toast.error("Failed to fetch candidates by election");
        throw error;
    }
};

// Delete multiple candidates (DELETE /api/delete)
export const deleteCandidates = async (selectedCandidates) => {
    try {
        const response = await axios.delete(
            `${BASE_URL}/delete`,
            {
                data: selectedCandidates,
                headers: { "Content-Type": "application/json" },
                withCredentials: true
            }
        );
        toast.success("Candidates deleted successfully");
        return response.data;
    } catch (error) {
        console.error("Error deleting candidates:", error);
        toast.error("Failed to delete candidates");
        throw error;
    }
};

// Delete candidates for a specific election (DELETE /api/election/{electionId}/candidates)
export const deleteCandidatesByElection = async (electionId) => {
    try {
        const response = await axios.delete(
            `${BASE_URL}/election/${electionId}/candidates`,
            { withCredentials: true }
        );
        toast.success("Candidates for the election deleted successfully");
        return response.data;
    } catch (error) {
        console.error("Error deleting candidates by election:", error);
        toast.error("Failed to delete candidates for the election");
        throw error;
    }
};
